import createSetter from "./createSetter";

export default function organismSlice(set) {
  return {
    setOrganism: createSetter(set, "organism"),
  };
}
